import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';

import {LoginGuard} from 'shared/guards/login.guard';
import {TargetGroupsListComponent} from './target-groups-list.component';

const routes: Routes = [
  {path: 'targetgroups/list', component: TargetGroupsListComponent, canActivate: [LoginGuard]},
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
  ],
  exports: [
    RouterModule,
  ],
})

export class TargetGroupsListRoutingModule { }



// WEBPACK FOOTER //
// /usr/src/app/src/app/modules/target-groups/target-groups-list/target-groups-list-routing.module.ts